import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
import { Gift, Check, User, Sparkles, AlertTriangle, ChevronDown } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function BonusesSection() {
  const [expandedBonuses, setExpandedBonuses] = useState<Record<number, boolean>>({});
  const toggleBonus = (index: number) => {
    setExpandedBonuses(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };
  return <section className="py-16 md:py-32 bg-white relative overflow-hidden" data-id="element-15">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none" data-id="element-16">
        <div className="absolute top-[10%] right-[-10%] w-[50%] h-[50%] rounded-full bg-sage-100/40 blur-3xl" data-id="element-17" />
        <div className="absolute bottom-[10%] left-[-10%] w-[50%] h-[50%] rounded-full bg-cream-200/60 blur-3xl" data-id="element-18" />
      </div>

      <div className="max-w-5xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-19">
        {/* Intro Block */}
        <FadeIn data-id="element-20">
          <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-21">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-charcoal mb-8" data-id="element-22">
              Pero eso no es todo.
            </h2>
            <div className="space-y-6 text-lg md:text-xl text-charcoal-light font-sans leading-relaxed" data-id="element-23">
              <p data-id="element-24">
                Cuando decidís empezar el Protocolo Anti-Inflamatorio 21D hoy,
                no recibís solo el ebook.
              </p>
              <p data-id="element-25">
                <strong className="text-charcoal" data-id="element-26">
                  Recibís todo lo que necesitás para que funcione de verdad,
                  desde el primer día.
                </strong>
              </p>
              <p data-id="element-27">
                Porque el mayor error que cometen las mujeres no es falta de
                información.{' '}
                <strong className="text-coral-500" data-id="element-28">Es falta de sistema.</strong>
              </p>
              <p data-id="element-29">
                Por eso agregué 3 bonos diseñados específicamente para eliminar
                las excusas, reducir la fricción y hacer que este protocolo se
                sostenga incluso los días donde tenés cero energía.
              </p>
            </div>
          </div>
        </FadeIn>

        {/* Bonus Cards */}
        <div className="space-y-16 md:space-y-24 mb-24" data-id="element-30">
          {/* BONO 1 */}
          <FadeIn data-id="element-31">
            <div className="bg-cream-50 rounded-[2.5rem] p-8 md:p-12 border border-cream-200 shadow-sm relative overflow-hidden" data-id="element-32">
              <div className="absolute top-0 right-0 bg-coral-500 text-white px-6 py-2 rounded-bl-2xl font-bold text-sm tracking-wider uppercase flex items-center gap-2" data-id="element-33">
                <Gift className="w-4 h-4" data-id="element-34" />
                Bono #1
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mt-6" data-id="element-35">
                <div className="order-2 lg:order-1" data-id="element-36">
                  <h3 className="text-2xl md:text-3xl font-bold text-charcoal mb-4" data-id="element-37">
                    Día 0 Express: Tu Cocina Anti-Inflamatoria en 60 Minutos
                  </h3>

                  <div className="flex items-center gap-3 mb-6" data-id="element-38">
                    <span className="text-lg text-charcoal-light line-through decoration-coral-500/50" data-id="element-39">
                      Valor real: $15.667 ARS
                    </span>
                    <span className="bg-sage-200 text-sage-800 font-bold px-3 py-1 rounded-full text-sm" data-id="element-40">
                      HOY: GRATIS
                    </span>
                  </div>

                  <div className="space-y-4 text-charcoal-light mb-4 lg:mb-8" data-id="element-41">
                    <p data-id="element-42">
                      Antes de arrancar el Día 1, tu entorno tiene que trabajar
                      para vos, no en tu contra. Este bono te da un sistema de
                      preparación de 60 minutos para convertir tu cocina en una
                      "Cocina de Hielo".
                    </p>
                    <p className="font-bold text-charcoal italic" data-id="element-43">
                      Sin fuerza de voluntad. Por diseño.
                    </p>
                  </div>

                  {/* Collapsible details - always visible on lg+ */}
                  <div className={`${expandedBonuses[1] ? 'block' : 'hidden'} lg:block`} data-id="element-44">
                    <div className="mb-8" data-id="element-45">
                      <h4 className="font-bold text-charcoal mb-4 uppercase tracking-wider text-sm" data-id="element-46">
                        Lo que recibís:
                      </h4>
                      <ul className="space-y-3" data-id="element-47">
                        {['Checklist imprimible "Limpieza Anti-Inflamatoria" (qué sacar, qué guardar, qué reemplazar)', 'Lista de compras "Zero Inflame" en 2 versiones: súper completo y versión presupuesto', 'Plantilla de 3 comidas base para días con cero energía (sin improvisar nunca más)', 'Kit Anti-Crisis nocturna (los 7 ítems que te salvan a las 11 PM)', 'Cronograma minuto a minuto para hacerlo todo en 60 minutos exactos', 'Etiquetas imprimibles para alacena y heladera (Verde / Amarillo / Rojo)'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-48">
                            <Check className="w-5 h-5 text-sage-600 flex-shrink-0 mt-0.5" data-id="element-49" />
                            <span className="text-charcoal-light" data-id="element-50">{item}</span>
                          </li>)}
                      </ul>
                    </div>

                    <div className="bg-white rounded-2xl p-6 border border-cream-200 space-y-4" data-id="element-51">
                      <div className="flex gap-4" data-id="element-52">
                        <User className="w-6 h-6 text-coral-500 flex-shrink-0" data-id="element-53" />
                        <div data-id="element-54">
                          <span className="font-bold text-charcoal block mb-1" data-id="element-55">
                            Para quién es:
                          </span>
                          <span className="text-charcoal-light text-sm" data-id="element-56">
                            Para la mujer que dice "quiero empezar pero no sé
                            por dónde" o que arrancó mil veces y a los 3 días
                            cayó porque no tenía nada listo en casa.
                          </span>
                        </div>
                      </div>
                      <div className="flex gap-4" data-id="element-57">
                        <Sparkles className="w-6 h-6 text-sage-600 flex-shrink-0" data-id="element-58" />
                        <div data-id="element-59">
                          <span className="font-bold text-charcoal block mb-1" data-id="element-60">
                            Resultado:
                          </span>
                          <span className="text-charcoal-light text-sm" data-id="element-61">
                            Al terminar el Día 0, tu cocina ya tomó partido. No
                            por fuerza de voluntad. Por diseño.
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Toggle button - mobile only */}
                  <button onClick={() => toggleBonus(1)} className="lg:hidden flex items-center gap-2 text-sage-600 font-bold text-sm mt-4 hover:text-sage-700 transition-colors" data-id="element-62">
                    {expandedBonuses[1] ? 'Ver menos' : 'Ver más detalles'}
                    <ChevronDown className={`w-4 h-4 transition-transform duration-300 ${expandedBonuses[1] ? 'rotate-180' : ''}`} data-id="element-63" />
                  </button>
                </div>

                <div className="order-1 lg:order-2 relative" data-id="element-64">
                  <div className="absolute inset-0 bg-sage-200 rounded-full blur-3xl opacity-40 transform scale-90" data-id="element-65"></div>
                  <img src="https://cdn.magicpatterns.com/uploads/5ik7emSk2pp2MfjtYLVXAh/Bono_01.png" alt="Bono 1: Día 0 Express" className="relative z-10 w-full max-w-md mx-auto rounded-2xl shadow-xl transform hover:-translate-y-2 transition-transform duration-500" data-id="element-66" />
                </div>
              </div>
            </div>
          </FadeIn>

          {/* BONO 2 */}
          <FadeIn data-id="element-67">
            <div className="bg-cream-50 rounded-[2.5rem] p-8 md:p-12 border border-cream-200 shadow-sm relative overflow-hidden" data-id="element-68">
              <div className="absolute top-0 right-0 bg-coral-500 text-white px-6 py-2 rounded-bl-2xl font-bold text-sm tracking-wider uppercase flex items-center gap-2" data-id="element-69">
                <Gift className="w-4 h-4" data-id="element-70" />
                Bono #2
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mt-6" data-id="element-71">
                <div className="order-1 lg:order-1 relative hidden lg:block" data-id="element-72">
                  <div className="absolute inset-0 bg-coral-200 rounded-full blur-3xl opacity-30 transform scale-90" data-id="element-73"></div>
                  <img src="https://cdn.magicpatterns.com/uploads/hMPn8w16TNjaYgzcuRYWwB/Bono_2.png" alt="Bono 2: Semáforo Anti-Inflamación" className="relative z-10 w-full max-w-md mx-auto rounded-2xl shadow-xl transform hover:-translate-y-2 transition-transform duration-500" data-id="element-74" />
                </div>

                <div className="order-2 lg:order-2" data-id="element-75">
                  <h3 className="text-2xl md:text-3xl font-bold text-charcoal mb-4" data-id="element-76">
                    Semáforo Anti-Inflamación: Guía de Supermercado + Etiquetas
                    (Argentina)
                  </h3>

                  <div className="flex items-center gap-3 mb-6" data-id="element-77">
                    <span className="text-lg text-charcoal-light line-through decoration-coral-500/50" data-id="element-78">
                      Valor real: $15.667 ARS
                    </span>
                    <span className="bg-sage-200 text-sage-800 font-bold px-3 py-1 rounded-full text-sm" data-id="element-79">
                      HOY: GRATIS
                    </span>
                  </div>

                  <div className="space-y-4 text-charcoal-light mb-4 lg:mb-8" data-id="element-80">
                    <p data-id="element-81">
                      La mayoría de las mujeres fracasa en el súper. No por
                      falta de voluntad. Este bono te da un sistema visual de
                      semáforo para tomar decisiones en segundos, sin tener que
                      "saber de nutrición".
                    </p>
                    <p className="font-bold text-charcoal italic" data-id="element-82">
                      Verde = sí. Amarillo = con cuidado. Rojo = afuera. Así de
                      simple.
                    </p>
                  </div>

                  <div className="order-1 relative lg:hidden mb-8" data-id="element-83">
                    <div className="absolute inset-0 bg-coral-200 rounded-full blur-3xl opacity-30 transform scale-90" data-id="element-84"></div>
                    <img src="https://cdn.magicpatterns.com/uploads/hMPn8w16TNjaYgzcuRYWwB/Bono_2.png" alt="Bono 2: Semáforo Anti-Inflamación" className="relative z-10 w-full max-w-md mx-auto rounded-2xl shadow-xl" data-id="element-85" />
                  </div>

                  {/* Collapsible details - always visible on lg+ */}
                  <div className={`${expandedBonuses[2] ? 'block' : 'hidden'} lg:block`} data-id="element-86">
                    <div className="mb-8" data-id="element-87">
                      <h4 className="font-bold text-charcoal mb-4 uppercase tracking-wider text-sm" data-id="element-88">
                        Lo que recibís:
                      </h4>
                      <ul className="space-y-3" data-id="element-89">
                        {['Guía completa VERDE / AMARILLO / ROJO adaptada al mercado argentino', 'Lista negra de palabras en etiquetas (si ves esto → rojo inmediato)', 'Lista blanca de señales "seguras" en cualquier producto', 'Checklist "Carrito Verde" imprimible (1 página, para ir al súper con claridad)', 'Tabla de reemplazos 1:1 (qué elegir cuando querés galletitas, aderezo, postre o snack salado)', 'Ritual anti-impulso de 2 minutos antes de pagar (para no caer en la góndola)', 'Mapa de pasillos (cómo recorrer el súper sin tentarte)'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-90">
                            <Check className="w-5 h-5 text-sage-600 flex-shrink-0 mt-0.5" data-id="element-91" />
                            <span className="text-charcoal-light" data-id="element-92">{item}</span>
                          </li>)}
                      </ul>
                    </div>

                    <div className="bg-white rounded-2xl p-6 border border-cream-200 space-y-4" data-id="element-93">
                      <div className="flex gap-4" data-id="element-94">
                        <User className="w-6 h-6 text-coral-500 flex-shrink-0" data-id="element-95" />
                        <div data-id="element-96">
                          <span className="font-bold text-charcoal block mb-1" data-id="element-97">
                            Para quién es:
                          </span>
                          <span className="text-charcoal-light text-sm" data-id="element-98">
                            Para la mujer que sabe "más o menos" qué comer pero
                            en el súper termina comprando lo mismo de siempre
                            porque no tiene un criterio claro y rápido.
                          </span>
                        </div>
                      </div>
                      <div className="flex gap-4" data-id="element-99">
                        <Sparkles className="w-6 h-6 text-sage-600 flex-shrink-0" data-id="element-100" />
                        <div data-id="element-101">
                          <span className="font-bold text-charcoal block mb-1" data-id="element-102">
                            Resultado:
                          </span>
                          <span className="text-charcoal-light text-sm" data-id="element-103">
                            Tu próxima compra ya es diferente. El carrito
                            cambia. La semana cambia. El protocolo se sostiene.
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Toggle button - mobile only */}
                  <button onClick={() => toggleBonus(2)} className="lg:hidden flex items-center gap-2 text-sage-600 font-bold text-sm mt-4 hover:text-sage-700 transition-colors" data-id="element-104">
                    {expandedBonuses[2] ? 'Ver menos' : 'Ver más detalles'}
                    <ChevronDown className={`w-4 h-4 transition-transform duration-300 ${expandedBonuses[2] ? 'rotate-180' : ''}`} data-id="element-105" />
                  </button>
                </div>
              </div>
            </div>
          </FadeIn>

          {/* BONO 3 */}
          <FadeIn data-id="element-106">
            <div className="bg-cream-50 rounded-[2.5rem] p-8 md:p-12 border border-cream-200 shadow-sm relative overflow-hidden" data-id="element-107">
              <div className="absolute top-0 right-0 bg-coral-500 text-white px-6 py-2 rounded-bl-2xl font-bold text-sm tracking-wider uppercase flex items-center gap-2" data-id="element-108">
                <Gift className="w-4 h-4" data-id="element-109" />
                Bono #3
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mt-6" data-id="element-110">
                <div className="order-2 lg:order-1" data-id="element-111">
                  <h3 className="text-2xl md:text-3xl font-bold text-charcoal mb-4" data-id="element-112">
                    Rescate en 10 Min: Scripts + Ritual Express para Calmar
                    Cortisol (AM/PM)
                  </h3>

                  <div className="flex items-center gap-3 mb-6" data-id="element-113">
                    <span className="text-lg text-charcoal-light line-through decoration-coral-500/50" data-id="element-114">
                      Valor real: $15.666 ARS
                    </span>
                    <span className="bg-sage-200 text-sage-800 font-bold px-3 py-1 rounded-full text-sm" data-id="element-115">
                      HOY: GRATIS
                    </span>
                  </div>

                  <div className="space-y-4 text-charcoal-light mb-4 lg:mb-8" data-id="element-116">
                    <p data-id="element-117">
                      El mayor saboteador del Protocolo 21D no es la comida. Es
                      el cortisol crónicamente elevado que dispara antojos,
                      retiene líquidos y te impide dormir profundo.
                    </p>
                    <p className="font-bold text-charcoal italic" data-id="element-118">
                      Sin apps. Sin equipo. Sin tiempo extra.
                    </p>
                  </div>

                  {/* Collapsible details - always visible on lg+ */}
                  <div className={`${expandedBonuses[3] ? 'block' : 'hidden'} lg:block`} data-id="element-119">
                    <div className="mb-8" data-id="element-120">
                      <h4 className="font-bold text-charcoal mb-4 uppercase tracking-wider text-sm" data-id="element-121">
                        Lo que recibís:
                      </h4>
                      <ul className="space-y-3" data-id="element-122">
                        {['Ritual AM de 10 minutos (4 pasos para arrancar sin disparar cortisol)', 'Ritual PM de 10 minutos (4 pasos para cerrar el día y dormir desinflamada)', 'Script AM listo (lo que te decís cuando querés tirar todo)', 'Script PM listo (lo que te decís cuando la culpa aparece a la noche)', 'Plan Anti-Heladera 11PM (secuencia de 90 segundos para cortar el impulso)', 'Tarjeta de bolsillo imprimible (respiración 4-2-8 + frases clave)', 'Tracker semanal SIN balanza (medís progreso real: energía, hinchazón, sueño, antojos)'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-123">
                            <Check className="w-5 h-5 text-sage-600 flex-shrink-0 mt-0.5" data-id="element-124" />
                            <span className="text-charcoal-light" data-id="element-125">{item}</span>
                          </li>)}
                      </ul>
                    </div>

                    <div className="bg-white rounded-2xl p-6 border border-cream-200 space-y-4" data-id="element-126">
                      <div className="flex gap-4" data-id="element-127">
                        <User className="w-6 h-6 text-coral-500 flex-shrink-0" data-id="element-128" />
                        <div data-id="element-129">
                          <span className="font-bold text-charcoal block mb-1" data-id="element-130">
                            Para quién es:
                          </span>
                          <span className="text-charcoal-light text-sm" data-id="element-131">
                            Para la mujer que empieza bien pero a las 3 PM o las
                            11 PM se cae. Para la que se duerme tarde, se
                            despierta cansada y no entiende por qué no baja la
                            hinchazón aunque "come bien".
                          </span>
                        </div>
                      </div>
                      <div className="flex gap-4" data-id="element-132">
                        <Sparkles className="w-6 h-6 text-sage-600 flex-shrink-0" data-id="element-133" />
                        <div data-id="element-134">
                          <span className="font-bold text-charcoal block mb-1" data-id="element-135">
                            Resultado:
                          </span>
                          <span className="text-charcoal-light text-sm" data-id="element-136">
                            En 7 días de usar estos rituales, tu sueño mejora,
                            tus antojos nocturnos bajan y tu cuerpo empieza a
                            desinflarse desde adentro.
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Toggle button - mobile only */}
                  <button onClick={() => toggleBonus(3)} className="lg:hidden flex items-center gap-2 text-sage-600 font-bold text-sm mt-4 hover:text-sage-700 transition-colors" data-id="element-137">
                    {expandedBonuses[3] ? 'Ver menos' : 'Ver más detalles'}
                    <ChevronDown className={`w-4 h-4 transition-transform duration-300 ${expandedBonuses[3] ? 'rotate-180' : ''}`} data-id="element-138" />
                  </button>
                </div>

                <div className="order-1 lg:order-2 relative" data-id="element-139">
                  <div className="absolute inset-0 bg-sage-200 rounded-full blur-3xl opacity-40 transform scale-90" data-id="element-140"></div>
                  <img src="https://cdn.magicpatterns.com/uploads/7r9Rp2PxBcAg937pdQcTBc/Bono_3.png" alt="Bono 3: Rescate en 10 Min" className="relative z-10 w-full max-w-md mx-auto rounded-2xl shadow-xl transform hover:-translate-y-2 transition-transform duration-500" data-id="element-141" />
                </div>
              </div>
            </div>
          </FadeIn>
        </div>

        {/* Summary Table & CTA */}
        <FadeIn data-id="element-142">
          <div className="bg-charcoal text-white rounded-2xl md:rounded-[2.5rem] p-5 md:p-12 shadow-2xl max-w-4xl mx-auto" data-id="element-143">
            <h3 className="text-xl md:text-3xl font-bold text-center mb-5 md:mb-8" data-id="element-144">
              Todo lo que recibís hoy:
            </h3>

            <div className="overflow-x-auto mb-5 md:mb-8" data-id="element-145">
              <table className="w-full text-left border-collapse text-sm md:text-base" data-id="element-146">
                <thead data-id="element-147">
                  <tr className="border-b border-white/20" data-id="element-148">
                    <th className="py-2 md:py-4 px-2 md:px-4 font-bold text-sage-200" data-id="element-149">
                      Producto
                    </th>
                    <th className="py-2 md:py-4 px-2 md:px-4 font-bold text-sage-200 text-right" data-id="element-150">
                      Valor Real
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-white/10" data-id="element-151">
                  <tr data-id="element-152">
                    <td className="py-2 md:py-4 px-2 md:px-4 flex items-center gap-2 md:gap-3" data-id="element-153">
                      <Check className="w-4 h-4 md:w-5 md:h-5 text-sage-400 flex-shrink-0" data-id="element-154" />
                      Protocolo 21D
                    </td>
                    <td className="py-2 md:py-4 px-2 md:px-4 text-right whitespace-nowrap" data-id="element-155">
                      $8.999
                    </td>
                  </tr>
                  <tr data-id="element-156">
                    <td className="py-2 md:py-4 px-2 md:px-4 flex items-center gap-2 md:gap-3" data-id="element-157">
                      <Gift className="w-4 h-4 md:w-5 md:h-5 text-coral-400 flex-shrink-0" data-id="element-158" />
                      Bono #1: Día 0 Express
                    </td>
                    <td className="py-2 md:py-4 px-2 md:px-4 text-right whitespace-nowrap" data-id="element-159">
                      $15.667
                    </td>
                  </tr>
                  <tr data-id="element-160">
                    <td className="py-2 md:py-4 px-2 md:px-4 flex items-center gap-2 md:gap-3" data-id="element-161">
                      <Gift className="w-4 h-4 md:w-5 md:h-5 text-coral-400 flex-shrink-0" data-id="element-162" />
                      Bono #2: Semáforo
                    </td>
                    <td className="py-2 md:py-4 px-2 md:px-4 text-right whitespace-nowrap" data-id="element-163">
                      $15.667
                    </td>
                  </tr>
                  <tr data-id="element-164">
                    <td className="py-2 md:py-4 px-2 md:px-4 flex items-center gap-2 md:gap-3" data-id="element-165">
                      <Gift className="w-4 h-4 md:w-5 md:h-5 text-coral-400 flex-shrink-0" data-id="element-166" />
                      Bono #3: Rescate 10 Min
                    </td>
                    <td className="py-2 md:py-4 px-2 md:px-4 text-right whitespace-nowrap" data-id="element-167">
                      $15.666
                    </td>
                  </tr>
                  <tr className="bg-white/5" data-id="element-168">
                    <td className="py-2 md:py-4 px-2 md:px-4 font-bold" data-id="element-169">
                      VALOR TOTAL
                    </td>
                    <td className="py-2 md:py-4 px-2 md:px-4 text-right font-bold line-through text-white/50 whitespace-nowrap" data-id="element-170">
                      $55.999
                    </td>
                  </tr>
                  <tr className="bg-sage-600/20" data-id="element-171">
                    <td className="py-3 md:py-6 px-2 md:px-4 font-bold text-lg md:text-xl text-sage-300" data-id="element-172">
                      Hoy pagás
                    </td>
                    <td className="py-3 md:py-6 px-2 md:px-4 text-right font-bold text-xl md:text-2xl text-sage-300 whitespace-nowrap" data-id="element-173">
                      $8.999
                    </td>
                  </tr>
                  <tr data-id="element-174">
                    <td colSpan={2} className="py-2 md:py-4 px-2 md:px-4 text-center font-bold text-coral-400 text-sm md:text-base" data-id="element-175">
                      Te ahorrás $47.000 ARS en bonos
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="bg-coral-500/10 border border-coral-500/30 rounded-xl md:rounded-2xl p-4 md:p-6 mb-6 md:mb-10 flex gap-3 md:gap-4 items-start" data-id="element-176">
              <AlertTriangle className="w-5 h-5 md:w-6 md:h-6 text-coral-400 flex-shrink-0 mt-0.5" data-id="element-177" />
              <div data-id="element-178">
                <h4 className="font-bold text-coral-400 mb-1 md:mb-2 text-sm md:text-base" data-id="element-179">
                  Aviso importante:
                </h4>
                <p className="text-white/80 text-xs md:text-sm leading-relaxed" data-id="element-180">
                  Los bonos son parte del lanzamiento inicial. No hay garantía
                  de que sigan disponibles al mismo precio mañana. Si estás
                  leyendo esto, todavía están incluidos.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}